import { useEffect } from "react";

// Reusable component to dynamically set the document title
function TabTitleChanger({ title }) {
  useEffect(() => {
    document.title = `${title} - gloves`; // Fallback to default if title is empty
  }, [title]); // Update title when the title prop changes

  return null; // Component doesn't render anything
}

export default TabTitleChanger;
